<template>
  <div>
    <v-app-bar class="white lighten-4" light>
      <img class="mr-3" src="https://s3.amazonaws.com/static.teamculture.com.br/logos/logo.svg" height="40"/>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-btn v-if="user" text router :to="'/'">Meus Treinamentos</v-btn>
        <v-btn v-if="user" text @click="logout">
          <span>Logout</span>
          <v-icon right>mdi-logout-variant</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
import firebaseApp from '@/firebase/init'

export default {
  name: 'Navbar',
  data () {
    return {
      user: null
    }
  },
  methods: {
    logout () {
      firebaseApp.auth().signOut().then(() => {
        this.$router.push({ name: 'Login' })
      })
    }
  },
  created () {
    firebaseApp.auth().onAuthStateChanged(() => {
      this.user = firebaseApp.auth().currentUser
    })
  }
}
</script>
